export default __webpack_public_path__ + "static/media/cover-apple-music.1a6f38ae.png";